import { analyticsApi } from 'src/services/analyticsApi'
import {
  AdPerfAccount,
  AdPerfActiveTimes,
  AdPerfAdDetail,
  AdPerfBreakdown,
  AdPerfCampaign,
  AdPerfCreatives,
  AdPerfOverview,
  AdPerfSmartInsights,
  AdPerfTrends,
} from './types'

export * from './types'

export interface AdPerfRange {
  accountId: string
  fromDate?: string
  toDate?: string
}

const BASE = '/v1_private/ad-performance'

const get = async <T>(path: string, params: Record<string, unknown>) => {
  const { data } = await analyticsApi().get<{ data: T }>(`${BASE}${path}`, {
    params,
  })
  return data.data
}

const rangeParams = ({ accountId, fromDate, toDate }: AdPerfRange) => ({
  account_id: accountId,
  fromDate,
  toDate,
})

export const adPerformanceApi = {
  accounts: () => get<AdPerfAccount[]>('/accounts', {}),
  activeTimes: (r: AdPerfRange, metric: string) =>
    get<AdPerfActiveTimes>('/active-times', { ...rangeParams(r), metric }),
  adDetail: (r: AdPerfRange, adId: string) =>
    get<AdPerfAdDetail>(`/ads/${adId}`, rangeParams(r)),
  breakdown: (r: AdPerfRange, dim: AdPerfBreakdown['dim']) =>
    get<AdPerfBreakdown>('/breakdown', { ...rangeParams(r), dim }),
  campaigns: (r: AdPerfRange) =>
    get<AdPerfCampaign[]>('/campaigns', rangeParams(r)),
  creatives: (r: AdPerfRange, format?: string) =>
    get<AdPerfCreatives>('/creatives', { ...rangeParams(r), format }),

  overview: (r: AdPerfRange) =>
    get<AdPerfOverview>('/overview', rangeParams(r)),
  // The latest generated set; not tied to the dashboard range.
  smartInsights: (accountId: string) =>
    get<AdPerfSmartInsights>('/smart-insights', { account_id: accountId }),
  trends: (r: AdPerfRange, metric: string) =>
    get<AdPerfTrends>('/trends', { ...rangeParams(r), metric }),
}
